export const DURESS_STATUS_RECEIVED = "DURESS_STATUS_RECEIVED";
